/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import PdpEmail from '../PlantDetail/pdpEmail';
import PdpPartners from '../PlantDetail/pdpPartners';
import PdpShopOnline from '../PlantDetail/pdpShopOnline';
const ShopifyMoreOptions = ({ openOptions, setOpenOptions, plantTitle, djangoPk = 0, partnersData, onAddToShopifyCart, variants, affiliatedLinks, }) => (React.createElement(Modal, { onClose: () => setOpenOptions(false), open: openOptions },
    React.createElement(Box, { className: "options_modal" },
        React.createElement("button", { type: "button", onClick: () => setOpenOptions(false), className: "close_btn" },
            React.createElement(CloseIcon, null)),
        React.createElement(Box, { className: "options_modal_wrapper" },
            React.createElement("h1", null,
                "Find",
                ' ',
                plantTitle),
            ((variants.length > 0 || (affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0)) && (React.createElement(PdpShopOnline, { djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart, variants: variants, affiliatedLinks: affiliatedLinks })),
            (partnersData.length > 0)
                && React.createElement(PdpPartners, { data: partnersData }),
            React.createElement("div", { className: "pdp_email_modal" },
                React.createElement("div", { className: "modal_item_container" },
                    React.createElement(PdpEmail, { isNotifyModal: false, plantId: djangoPk, plantName: plantTitle })))))));
export default ShopifyMoreOptions;
